import type { Point } from "../geometry/Point"
import type { Distance } from "../units/Units"
import type { ConcretePlotObject } from "./BasePlotObject"
import type { PlotFunction } from "./PlotFunction"

// Specific type for plot_path
export type PlotPath = {
  enum: PlotFunction.PLOT_PATH
  points: Point<Distance>[]
  closed?: boolean
} & ConcretePlotObject
